import request from '@/utils/request'

//图表数据接口
export function loadEcharts() {
  return request({
    url: '/get_home_echarts',
    method: 'post',
  })
}